import { INVESTMENT_PROFILE_QUERY } from 'graphql/kycIdentity/queries/investmentProfileQuery';
import { useLandaApiLazyQuery } from 'hooks/api/graphql/landa_api';
import { useEffect } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { useKycStore } from 'stores/KYCIdentities/kycIdentities';
import { InvestmentProfile } from 'types/kyc-identities-types';

const init: { investmentProfile?: InvestmentProfile; loading: boolean } = {
  investmentProfile: undefined,
  loading: false,
};

const useInvestmentProfile = () => {
  const { kycIdentities, setInvestmentProfile } = useKycStore();
  const [fetchInvestmentProfile, { loading }] = useLandaApiLazyQuery(
    INVESTMENT_PROFILE_QUERY
  );
  const investmentProfile = kycIdentities?.attributes?.investment_profile;

  useEffect(() => {
    if (!investmentProfile) {
      fetchInvestmentProfile({
        onCompleted: ({ kycIdentity }) => {
          setInvestmentProfile(kycIdentity.personalInformation);
        },
      });
    }
  }, [investmentProfile]);

  return { investmentProfile, loading };
};

export default singletonHook(init, useInvestmentProfile);
